module.exports = __webpack_public_path__ + "static/media/woman.cb265142.svg";